export const BLOCK_PAGES = {
  FETCH: {
    REQUEST: 'BLOCK_PAGES.FETCH.REQUEST',
    RECEIVE: 'BLOCK_PAGES.FETCH.RECEIVE',
    FAILURE: 'BLOCK_PAGES.FETCH.FAILURE'
  },
  GET: 'BLOCK_PAGES.GET'
};

export const requestBlockPages = () => {
  return {
    type: BLOCK_PAGES.FETCH.REQUEST,
  }
}

export const receiveBlockPages = (items) => {
  return {
    type: BLOCK_PAGES.FETCH.RECEIVE,
    items
  }
}

export const getBlockPages = () => {
  return {
    type: BLOCK_PAGES.GET
  }
}

export const failedBlockPages = (error) => {
  return {
    type: BLOCK_PAGES.FETCH.FAILURE,
    error
  }
}